import React, { useState } from 'react';
import { dealsTooltipIcon, dealsTooltipIconHovered } from './assets';

type Props = {
  text: string;
  top?: string;
  left?: string;
  width?: string;
  height?: string;
  iconMarginTop?: string;
  iconMarginLeft?: string;
};

export const DetailedViewTooltip: React.FC<Props> = ({
  text,
  top,
  left,
  width,
  height,
  iconMarginTop,
  iconMarginLeft,
}): JSX.Element => {
  const [open, setOpen] = useState(false);

  const toggleTooltip = () => {
    setOpen(!open);
  };

  return (
    <div className="detailed-view-tooltip">
      <img
        style={{ marginTop: iconMarginTop, marginLeft: iconMarginLeft }}
        className="detailed-view-tooltip__icon"
        src={open ? dealsTooltipIconHovered : dealsTooltipIcon}
        alt=""
        onMouseEnter={toggleTooltip}
        onMouseLeave={toggleTooltip}
      />
      <div
        style={{ top, left, width, height }}
        className={
          open
            ? 'open detailed-view-tooltip__popup'
            : 'detailed-view-tooltip__popup'
        }
      >
        {text}
      </div>
    </div>
  );
};
